export default {
  baseStyle: {
    text: {
      fontSize: 12,
      marginTop: 1,
      marginBottom: 1,
    },
  },
};
